import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    userDetails: null,
    loading: false,
    token: localStorage.getItem("token") 
}

const userAuthSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUserData(state, value) {
      state.userDetails = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    },
    setToken(state, value) {
      state.token = value.payload;
    },
  },
});

export const { setUserData, setLoading, setToken } = userAuthSlice.actions;

export default userAuthSlice.reducer;